<template>
  <div>
    <div class="planetry-table mr-auto mx-auto">
      <table class="table">
        <tr class="header-row">
          <td class="header-cell" colspan="2">Planet</td>
          <td class="header-cell" colspan="2">Sign</td>
          <td class="header-cell small-cell">K</td>
          <td class="header-cell small-cell">D</td>
          <td class="header-cell">Nak.</td>
          <td class="header-cell">P</td>
          <td class="header-cell small-cell">L</td>
          <td class="header-cell">Deg.</td>
          <td class="header-cell">Dec.</td>
          <td class="header-cell">Speed</td>
        </tr>

        <tr class="lagna-row" v-if="lagna">
          <td class="cell center bold" colspan="2">

            <span><strong>As</strong></span>


          </td>
          <td class="cell center bold" colspan="2">
            <span>
                {{ lagna["Lg"]["rashi_name"] }}
            </span>
          </td>
          <td class="cell center bold">-</td>
          <td class="cell center">-</td>
          <td class="cell center bold">{{ lagna["Lg"]["nakshatra"]["name"] }}</td>
          <td class="cell center bold">{{ lagna["Lg"]["nakshatra"]["pada"] }}</td>
          <td class="cell center bold">{{ lagna["Lg"]["nakshatra"]["lord"] }}</td>
          <td class="cell center bold">{{ formatDegree(lagna["Lg"]) }}</td>
          <td class="cell center bold">-</td>
          <td class="cell center bold">-</td>
        </tr>

        <tr
            class="planet-row"
            v-for="item in planet_order"
            :key="item"
            :style="`background-color: ${getPlanetRowBg(grahas[item]['rashiAvastha'], item)};`"
        >
          <td class="cell center bold" colspan="2">

            <span> <img
                :src="
            site_url +  '/wp-content/plugins/hora-v2/statics/images/icons/' +
            item +
            '.svg'
          "
                width="37"
            /></span>
            <span> <strong>{{ formatPlanetName(item) }}</strong></span>


            <span v-if="grahas[item]['astangata']">
        </span>
          </td>
          <td class="cell center" colspan="2">


            <span>
                {{ grahas[item]["rashi_name"] }}
            </span>



          </td>
          <td class="cell center">{{ grahas[item]["karaka"] }}</td>
          <td class="cell center">{{ dignityText(grahas[item], item) }}</td>
          <td class="cell center">{{ grahas[item]["nakshatra"]["name"] }}</td>
          <td class="cell center">{{ grahas[item]["nakshatra"]["pada"] }}</td>
          <td class="cell center">{{ grahas[item]["nakshatra"]["lord"] }}</td>
          <td class="cell center">{{ formatDegree(grahas[item]) }}</td>
          <td class="cell center">
        <span v-if="item !== 'Ra' && item !== 'Ke'">
          {{ formatDegreeDec(grahas[item]) }}
        </span>
            <span v-else>-</span>
          </td>
          <td class="cell center">{{ formatSpeed(grahas[item]) }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import HelperLib from "./helper";

export default {
  name: "PlanetryTableReport",
  components: {
    HelperLib,
  },
  props: {
    grahas: {
      type: Object,
    },
    lagna: {
      type: Object,
    },
    box_width: {
      type: Number,
    },
  },
  data() {
    return {
      planet_order: ["Su", "Mo", "Ma", "Me", "Ju", "Ve", "Sa", "Ra", "Ke"],
      font_size: "14px",
      site_url: null,
    };
  },
  mounted() {
      this.site_url = process.env.BASE_URL;
    if (HelperLib.isMobile()) {
      this.font_size = "12px";
    }
    this.createPlanetryTable();
  },
  methods: {
    getPlanetRowBg(text, item) {
      if (item == 'Ra' || item == 'Ke'){
        if ( text != "neecha" || text != "swa"){
          return "";
        }
        if ( text == "swa"){
          return "rgba(50, 147, 35, 0.15)";
        }
        if ( text == "neecha"){
          return "rgba(181, 32, 32, 0.15)";
        }
      }
      if (text == "neecha") {
        return "rgba(181, 32, 32, 0.15)";
      }
      if (text == "swa") {
        return "rgba(50, 147, 35, 0.15)";
      }
      if (text == "mool") {
        return "rgba(50, 147, 35, 0.15)";
      }
      if (text == "ucha") {
        return "rgba(50, 147, 35, 0.15)";
      } else {
        return "";
      }
    },
    dignityText(graha, item) {
      // console.log(item)
      if (item == 'Ra' || item == 'Ke'){
        if ( graha["rashiAvastha"] != "neecha" || graha["rashiAvastha"] != "swa"){
          return "-";
        }
      }
      const text = graha["rashiAvastha"];
      if (text == "neecha") {
        return "DB";
      }
      if (text == "swa") {
        return "OH";
      }
      if (text == "mool") {
        return "MT";
      }
      if (text == "ucha") {
        return "EX";
      }
      if (text == "friend") {
        return "F";
      }
      if (text == "enemy") {
        return "E";
      }
      if (text == "neutral") {
        return "N";
      }
    },
    createPlanetryTable() {
      // tbl_order.forEach(element => {
      // });
    },
    formatDegreeLat(graha) {
      return HelperLib.formatDegText(
        graha["latitude_dms"]["deg"],
        graha["latitude_dms"]["min"],
        parseInt(graha["latitude_dms"]["sec"])
      );
    },
    formatSpeed(graha) {
      const speed = graha["speed"];
      const sign = speed >= 0 ? 1 : -1;

      // Convert the speed to a positive value for calculations
      const absSpeed = Math.abs(speed);

      // Calculate the degrees, minutes, and seconds
      const degrees = Math.floor(absSpeed);
      const minutes = Math.floor((absSpeed - degrees) * 60);
      const seconds = ((absSpeed - degrees - minutes / 60) * 3600).toFixed(2);

      // const speed = HelperLib.convertDegreeToDMS(graha['speed'])
      const dmsString = `${HelperLib.paddy(Math.abs(degrees), 2, "0")}°${HelperLib.paddy(
        Math.abs(minutes),
        2,
        "0"
      )}'${HelperLib.paddy(parseInt(Math.abs(seconds)), 2, "0")}"`;

      return sign === -1 ? "-" + dmsString : dmsString;
    },
    formatDegreeDec(graha) {
      const dec = HelperLib.convertDegreeToDMS(graha["declination"]);
      return HelperLib.formatDegText(dec["deg"], dec["min"], parseInt(dec["sec"]));
    },
    formatDegree(graha) {
      return HelperLib.formatDegText(
        graha["degree_dms"]["deg"],
        graha["degree_dms"]["min"],
        parseInt(graha["degree_dms"]["sec"])
      );
    },
    formatPlanetName(graha) {

      let name = graha;
      if (this.grahas[graha]["speed"] < 0 && graha !== "Ra" && graha !== "Ke") {
        name = name + "R";
      }
      return name;
    },

    formatPlanetId(graha) {
      let Ids = {
        "Su":"1",
        "Mo":"2",
        "Ma":"3",
        "Me":"4",
        "Ju":"5",
        "Ve":"6",
        "Sa":"7",
        "Ra":"8",
        "Ke":"9",
      }
      return Ids[graha];
    },


    formatRashiId(name) {
      const rashiNames = {
        "Aries": 1,
        "Taurus": 2,
        "Gemini": 3,
        "Cancer": 4,
        "Leo": 5,
        "Virgo": 6,
        "Libra": 7,
        "Scorpio": 8,
        "Saggitarius": 9,
        "Capricorn": 10,
        "Aquarius": 11,
        "Pisces": 12
      };
      const formattedName = name.replace(/\s+/g, '');
      return rashiNames[formattedName];
    },
  },
};
</script>

<style scoped>



</style>